export const getQueryParamValue = (search: string, key: string) => {
  return new URLSearchParams(search).get(key);
};
